import React from 'react';
//MUI
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
//DS
import DialogBase from '../../atomicos/DialogBase';

const useStyles = makeStyles(theme => ({
    progress: {
        margin: theme.spacing(2),
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));

const LoadingModal = ({mensaje,circularProgressProps,...otros}) => {
    const classes = useStyles();
    return (
        <DialogBase {...otros} disableBackdropClick disableEscapeKeyDown>
            <div className={classes.root}>
                <CircularProgress className={classes.progress} {...circularProgressProps}/>
                <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                    Cargando...
            </Typography>
                <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                    {mensaje || 'Por favor espere.'}
                </Typography>
            </div>
        </DialogBase>
    );
}

export default LoadingModal;